'use client';

import './nav-search.scss';

import { useTranslation } from 'react-i18next';

import { Link } from '@sola/ark-core/atoms/link/link.js';
import { cn } from '@sola/ark-core/utils/helpers.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

interface NavSearchProps {
  className?: string;
}

export const NavSearch = ({ className }: NavSearchProps) => {
  const { t } = useTranslation(['priority', 'common']);

  return (
    <Link
      className={cn('NavSearch flex p-comfy-xs relative', className)}
      href="/search"
      title={t('skippy.article.search')}
    >
      <ArkIcon iconName="search-sm" className="NavSearch__icon" size="1.5em" />
    </Link>
  );
};
